module.exports = __webpack_public_path__ + "img/production4.469933f9.png";